import useAPI from './useAPI'

export default function useCustomers(queryParams) {
  const { data, error, mutate } = useAPI('/customers', 'GET', null, queryParams)

  return {
    count: data?.count,
    items: data?.result.Items,
    lastEvaluatedKey: data?.result.LastEvaluatedKey,
    isLoading: !data && !error,
    error,
    mutate,
  }
}
